import { useState, useRef } from "react";
import { SearchResultGroupInterface } from "../interface/search-result-interface";
import { SearchState, ResultGroup, ResultType } from "../types/types";

export const useSearch = <TResultType extends ResultType>(
    searchResultGroups: SearchResultGroupInterface<TResultType>[]
): [(searchString: string) => void, ResultGroup<TResultType>[], SearchState, string] => {
    const [searchState, setSearchState] = useState(SearchState.IDLE);
    const [searchResults, setSearchResults] = useState<ResultGroup<TResultType>[]>([]);
    const searchStringRef = useRef(null);

    const handleSearch = async (searchString: string) => {
        // When user has characters inside the search box
        if (searchString === "") {
            setSearchResults([]);
            setSearchState(SearchState.IDLE);
        } else {
            setSearchState(SearchState.SEARCHING);
            const searchResponse = await Promise.all(searchResultGroups.map((group) => group.getResults(searchString)));
            const resultGroups: ResultGroup<TResultType>[] = searchResponse
                .filter(({ results }) => results.length > 0)
                .map(({ results, type }) => {
                    const searchResultGroup = searchResultGroups.find((group) => group.type === type);
                    return {
                        type,
                        name: searchResultGroup.name,
                        icon: searchResultGroup.icon,
                        results,
                        onResultClick: (result: TResultType, displayText: string) => searchResultGroup.onResultClick(result, displayText),
                    };
                });
            searchStringRef.current = searchString;
            setSearchResults(resultGroups);
            setSearchState(SearchState.SHOWING_RESULTS);
        }
    };
    return [handleSearch, searchResults, searchState, searchStringRef.current];
};
